export const EXSBPERIODTYPE_CREATE_RESET = 'EXSBPERIODTYPE_CREATE_RESET'
export const EXSBPERIODTYPE_CREATE_SET_CREATED = 'EXSBPERIODTYPE_CREATE_SET_CREATED'
export const EXSBPERIODTYPE_CREATE_SET_ERROR = 'EXSBPERIODTYPE_CREATE_SET_ERROR'
export const EXSBPERIODTYPE_CREATE_SET_VIOLATIONS = 'EXSBPERIODTYPE_CREATE_SET_VIOLATIONS'
export const EXSBPERIODTYPE_CREATE_TOGGLE_LOADING = 'EXSBPERIODTYPE_CREATE_TOGGLE_LOADING'
